import React, { useEffect, useRef, useState } from "react";
import { getBaseUrl } from "../../../../../../Redux/Config/AppConfig";
import Select from "react-select";

const AddOffer = ({ selectedOffer, setListUpdated, setSelectedOffer }) => {
  const BaseUrl = getBaseUrl();
  const closeBtnRef = useRef(null);
  const [roomList, setRoomList] = useState([]);

  const [formData, setFormData] = useState({
    offer_name: "",
    room_type_id: "",
    offer_type: "",
    valid_date_from: "",
    valid_date_to: "",
    discount_type: "",
    discount_value: "",
  });

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        let token = localStorage.getItem("token");
        let hotel_id = localStorage.getItem("hotel_id");

        const res = await fetch(`${BaseUrl}/room/room-types?hotel_id=${hotel_id}&page=1`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
        });
        const data = await res.json();
        setRoomList(
          (data?.data?.rooms || []).map((room) => ({
            value: room.id,
            label: room.room_type || `Room ${room.room_number}`,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch rooms:", err);
      }
    };

    fetchRooms();
  }, [BaseUrl]);
  
  useEffect(() => {
    if (selectedOffer) {
      setFormData({
        offer_name: selectedOffer.offer_name || "",
        room_type: selectedOffer.room_type_id || "",
        offer_type: selectedOffer.offer_type || "",
        valid_date_from: selectedOffer.valid_date_from?.split("T")[0] || "",
        valid_date_to: selectedOffer.valid_date_to?.split("T")[0] || "",
        discount_type: selectedOffer.discount_type || "percentage",
        discount_value: selectedOffer.discount_value?.toString() || "",
      });
      setErrors({});
    } else {
      setFormData({
        offer_name: "",
        room_type_id: "",
        offer_type: "",
        valid_date_from: "",
        valid_date_to: "",
        discount_type: "",
        discount_value: "",
      });
      setErrors({});
    }
  }, [selectedOffer]);

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.offer_name.trim())
      newErrors.offer_name = "Offer name is required.";
    if (!formData.room_type) newErrors.room_type = "Room type is required.";
    if (!formData.offer_type) newErrors.offer_type = "Offer type is required.";
    if (!formData.valid_date_from)
      newErrors.valid_date_from = "Valid from date is required.";
    if (!formData.valid_date_to)
      newErrors.valid_date_to = "Valid to date is required.";
    if (!formData.discount_type)
      newErrors.discount_type = "Discount type is required.";
    if (
      formData.discount_value === "" ||
      isNaN(formData.discount_value) ||
      Number(formData.discount_value) <= 0
    ) {
      newErrors.discount_value = "Valid discount value is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    if (validate()) {
      const AddUrl = `${BaseUrl}/room/offer`;
      const EditUrl = `${BaseUrl}/room/offer/${selectedOffer?.id}`;
      const methodType = selectedOffer ? "PUT" : "POST";
      try {
        let token = localStorage.getItem("token");
    let hotel_id = localStorage.getItem("hotel_id");
        
        const res = await fetch(selectedOffer ? EditUrl : AddUrl, {
          method: methodType,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({
            offer_name: formData.offer_name,
            room_type_id: formData.room_type,
            offer_type: formData.offer_type,
            valid_date_from: formData.valid_date_from,
            valid_date_to: formData.valid_date_to,
            discount_type: formData.discount_type,
            discount_value: parseFloat(formData.discount_value),
            hotel_id: hotel_id,
          }),
        });
        

        const response = await res.json();
        setListUpdated((prev) => !prev);
        closeBtnRef.current?.click();
        setSelectedOffer(null);
        setFormData({
          offer_name: "",
          room_type_id: "",
          offer_type: "",
          valid_date_from: "",
          valid_date_to: "",
          discount_type: "",
          discount_value: "",
        });
      } catch (error) {
        console.error("Error submitting offer:", error);
        setFormData({
          offer_name: "",
          room_type_id: "",
          offer_type: "",
          valid_date_from: "",
          valid_date_to: "",
          discount_type: "",
          discount_value: "",
        });
      }
    }
  };

  const handleClear = () => {
    setFormData({
      offer_name: "",
      room_type: "",
      offer_type: "",
      valid_date_from: "",
      valid_date_to: "",
      discount_type: "",
      discount_value: "",
    });
    setErrors({});
  };


  // const handleRoomChange = (selectedOption) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     room_type: selectedOption ? selectedOption.label : "",
  //   }));
  //   setErrors((prev) => ({ ...prev, room_type: "" }));
  // };
  const handleRoomChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      room_type: selectedOption ? selectedOption.value : "",
    }));
    setErrors((prev) => ({ ...prev, room_type: "" }));
  };
  
  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex="-1"
      id="add-offer"
      aria-labelledby="add-offer"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">
          {selectedOffer ? "Edit Offer" : "Add Offer"}
        </h5>
        <button
          ref={closeBtnRef}
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => setErrors({})}
        ></button>
      </div>
      <div className="offcanvas-body">
        <form>
          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Offer Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              name="offer_name"
              className={`form-control ${
                errors.offer_name ? "is-invalid" : ""
              }`}
              placeholder="Enter Offer Name"
              value={formData.offer_name}
              onChange={handleChange}
            />
            {errors.offer_name && (
              <div className="invalid-feedback">{errors.offer_name}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Room Type <span className="text-danger">*</span>
            </label>
            <Select
              name="room_type"
              options={roomList}
              classNamePrefix="select"
              className={errors.room_type ? "react-select is-invalid" : "react-select"}
              onChange={handleRoomChange}
              // value={
              //   roomList.find((opt) => opt.label === formData.room_type) || null
              // }
              value={roomList.find((opt) => opt.value === formData.room_type) || null}

            />

            {errors.room_type && (
              <div className="invalid-feedback">{errors.room_type}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Offer Type <span className="text-danger">*</span>
            </label>
            <select
              name="offer_type"
              className={`form-select ${errors.offer_type ? "is-invalid" : ""}`}
              value={formData.offer_type}
              onChange={handleChange}
            >
              <option value="">Choose Offer Type</option>
              <option value="seasonal">Seasonal</option>
              <option value="weekend">WeekEnd</option>
              {/* <option value="custom">Custom</option> */}
            </select>
            {errors.offer_type && (
              <div className="invalid-feedback">{errors.offer_type}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Valid From <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="valid_date_from"
              className={`form-control ${
                errors.valid_date_from ? "is-invalid" : ""
              }`}
              value={formData.valid_date_from}
              onChange={handleChange}
            />
            {errors.valid_date_from && (
              <div className="invalid-feedback">{errors.valid_date_from}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Valid To <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              name="valid_date_to"
              className={`form-control ${
                errors.valid_date_to ? "is-invalid" : ""
              }`}
              value={formData.valid_date_to}
              onChange={handleChange}
            />
            {errors.valid_date_to && (
              <div className="invalid-feedback">{errors.valid_date_to}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Discount Type <span className="text-danger">*</span>
            </label>
            <select
              name="discount_type"
              className={`form-select ${
                errors.discount_type ? "is-invalid" : ""
              }`}
              value={formData.discount_type}
              onChange={handleChange}
            >
              <option value="">Choose Discount Type</option>
              <option value="percentage">Percentage</option>
              {/* <option value="flat">Flat</option> */}
            </select>
            {errors.discount_type && (
              <div className="invalid-feedback">{errors.discount_type}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="form-label text-muted">
              Discount Value <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              name="discount_value"
              className={`form-control ${
                errors.discount_value ? "is-invalid" : ""
              }`}
              placeholder="Enter Discount Value"
              value={formData.discount_value}
              onChange={handleChange}
            />
            {errors.discount_value && (
              <div className="invalid-feedback">{errors.discount_value}</div>
            )}
          </div>
        </form>

        <div className="d-flex">
          <button
            type="button"
            className="btn w-100 me-1 py-2 btn-primary"
            onClick={handleClear}
          >
            Clear
          </button>
          <button
            type="button"
            className="btn w-100 ms-1 py-2 btn-dark"
            onClick={handleSubmit}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOffer;
